<div class="row" *ngIf="authorised">
    <div class="col-12 px-xl-5 grillaMovies">
        <div class="row">
            <div class="col-12 my-4">
                <h1 class="text-white font-weight-bolder mb-0">
                    Sala de Prensa
                </h1>
                <p class="lead text-muted mb-0 animate__animated animate__fadeIn animate__faster" *ngIf="!loading">
                    Peliculas disponibles en la sala para miembros de la prensa
                </p>

                <div class="spinner-border mt-2" style="width: 3rem; height: 3rem" role="status" *ngIf="loading">
                    <span class="sr-only">Cargando...</span>
                </div>
            </div>
        </div>

        <div class="row grilla animate__animated animate__fadeIn" *ngIf="movies.length > 0 && !loading">
            <div class="col col-12 col-md-6 col-lg-4 col-xl-3 " *ngFor="let movie of movies">
                <div class="card">
                    <app-movie-item class="movie-item" [movie]="movie"></app-movie-item>
                </div>
            </div>
        </div>

        <div class="row p-lg-5" *ngIf="movies.length == 0 && !loading">
            <div class="sinResultado p-lg-5">
                <div class="icono">
                    <i class="fas fa-heart-broken"></i>
                </div>
                <p class="text-muted">
                    El catálogo está vacío.
                </p>
            </div>
        </div>
    </div>
</div>